import { createContext, Dispatch, FCWithChildren, SetStateAction, useContext, useState } from 'react';
import { BuyingOffer, PaginationState } from '@interfaces/models/negotiation/domain/BuyingOffer';

interface BuyingOffersContextProps {
  buyingOffersList: BuyingOffer[];
  setBuyingOffersList: Dispatch<SetStateAction<BuyingOffer[]>>;
  buyingOffersPaginationMeta: PaginationState;
  setBuyingOffersPaginationMeta: Dispatch<SetStateAction<PaginationState>>;
}

const BuyingOffersContext = createContext<BuyingOffersContextProps>({} as BuyingOffersContextProps);

const BuyingOffersProvider: FCWithChildren = ({ children }) => {
  const [buyingOffersList, setBuyingOffersList] = useState<BuyingOffer[]>([]);

  const [buyingOffersPaginationMeta, setBuyingOffersPaginationMeta] = useState<PaginationState>(null);

  const value = {
    buyingOffersList,
    setBuyingOffersList,
    buyingOffersPaginationMeta,
    setBuyingOffersPaginationMeta,
  };

  return <BuyingOffersContext.Provider value={value}>{children}</BuyingOffersContext.Provider>;
};

const useBuyingOffers = () => useContext(BuyingOffersContext);

export { BuyingOffersProvider, useBuyingOffers };
